module.exports = __webpack_public_path__ + "img/57-green.1fe7c49a.svg";